// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "../../../theme/Theme__Fonts.bs.js";

var listWrapper = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.backgroundColor(Theme__Color$PrezzeeRibbon.Personal.white),
      BsCssJs$PrezzeeRibbon.borderBottomRightRadius(BsCssJs$PrezzeeRibbon.rem(1.5)),
      BsCssJs$PrezzeeRibbon.borderBottomLeftRadius(BsCssJs$PrezzeeRibbon.rem(1.5)),
      BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(100.0)),
      BsCssJs$PrezzeeRibbon.selector("ul", [
            BsCssJs$PrezzeeRibbon.color(Theme__Color$PrezzeeRibbon.Personal.darkGrey),
            BsCssJs$PrezzeeRibbon.listStyleType("none"),
            BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(0)),
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.rem(0.375)),
            BsCssJs$PrezzeeRibbon.paddingRight(BsCssJs$PrezzeeRibbon.rem(1.25)),
            BsCssJs$PrezzeeRibbon.unsafe("marginBlockStart", "0px"),
            BsCssJs$PrezzeeRibbon.unsafe("marginBlockEnd", "0.375rem"),
            Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
            BsCssJs$PrezzeeRibbon.paddingLeft(BsCssJs$PrezzeeRibbon.rem(1.25))
          ])
    ]);

var Styles = {
  listWrapper: listWrapper
};

function SearchBar__SuggestionList(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx("ul", {
                    children: props.children
                  }),
              className: listWrapper
            });
}

var make = SearchBar__SuggestionList;

export {
  Styles ,
  make ,
}
/* listWrapper Not a pure module */
